import { isSignupMinorState } from '@/helpers/signupMinorState';
import type { ParentalConsentFormData } from '@/types/parental-consent';
import type { SignupMinorNavigationState } from '@/types/signup';

export type ParentalConsentReturnState = {
  minorData: SignupMinorNavigationState;
  form: ParentalConsentFormData;
};

function isParentalConsentFormData(value: unknown): value is ParentalConsentFormData {
  if (!value || typeof value !== 'object') {
    return false;
  }
  const record = value as Record<string, unknown>;
  return (
    typeof record.guardianFullName === 'string' &&
    typeof record.guardianEmail === 'string' &&
    typeof record.guardianCpf === 'string' &&
    typeof record.guardianPhone === 'string' &&
    typeof record.guardianRelationship === 'string' &&
    typeof record.consentGiven === 'boolean'
  );
}

export function isParentalConsentReturnState(
  value: unknown,
): value is ParentalConsentReturnState {
  if (!value || typeof value !== 'object') {
    return false;
  }
  const record = value as Record<string, unknown>;
  return isSignupMinorState(record.minorData) && isParentalConsentFormData(record.form);
}

export function hasValidParentalConsentNavigationState(state: unknown): boolean {
  return isSignupMinorState(state) || isParentalConsentReturnState(state);
}

export function parseParentalConsentNavigationState(state: unknown): {
  minorData: SignupMinorNavigationState | null;
  form: ParentalConsentFormData | null;
} {
  if (isParentalConsentReturnState(state)) {
    return { minorData: state.minorData, form: state.form };
  }
  if (isSignupMinorState(state)) {
    return { minorData: state, form: null };
  }
  return { minorData: null, form: null };
}
